import { useState, useEffect } from 'react'
import { fetchDocContent } from '../api'
import LoadingView from './LoadingView'

interface DocPageProps {
  targetId: string
}

export default function DocPage({ targetId }: DocPageProps) {
  const [text,    setText]    = useState('')
  const [loading, setLoading] = useState(false)
  const [error,   setError]   = useState<string | null>(null)

  useEffect(() => {
    setLoading(true)
    setError(null)
    fetchDocContent(targetId)
      .then((data) => setText(data.text))
      .catch((e) => setError(e instanceof Error ? e.message : 'Failed to load'))
      .finally(() => setLoading(false))
  }, [targetId])

  if (loading) return <LoadingView />

  if (error) {
    return (
      <div style={{ flex: 1, padding: '24px' }}>
        <div style={{ padding: '10px 14px', background: '#450a0a', color: '#fca5a5', fontSize: '13px', borderRadius: '8px', border: '1px solid #7f1d1d' }}>
          ⚠ {error}
        </div>
      </div>
    )
  }

  return (
    <div style={{ flex: 1, overflowY: 'auto', padding: '24px 20px' }}>
      {text ? (
        <pre
          style={{
            fontFamily: 'var(--font)',
            fontSize: '13px',
            color: 'var(--text)',
            whiteSpace: 'pre-wrap',
            lineHeight: 1.65,
            margin: 0,
          }}
        >
          {text}
        </pre>
      ) : (
        <div style={{ color: 'var(--text-muted)', fontSize: '14px', opacity: 0.6 }}>
          Empty document.
        </div>
      )}
    </div>
  )
}
